<template>
  <section class="welfare">
    <div class="center">
      <h3>补贴福利如何省钱</h3>
      <p>以深圳国企为例：若每月发放员工补贴1000元，员工个税缴纳比例是月薪的20%。</p>
      <div class="content">
        <div class="list">
          <p>补贴计入工资科目</p>
          <div>
            <div class="tip">
              <span class="p">员工所得 ￥600</span>
              <span class="col">￥140</span>
            </div>
          </div>
        </div>
        <div class="list">
          <p>福利助手餐费计入福利科目</p>
          <div>
            <div class="tip">
              <span class="p">员工所得 ￥800</span>
            </div>
          </div>
        </div>
        <div class="info">综上：使用福利助手企业补贴解决方案，企业成本节约<span class="col">40%</span>,员工所得增加<span class="col">20%</span>。</div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'Welfare',
  props: {
  }
}
</script>
<style scoped lang="less">
.welfare {
  height: 506px;
  width: 100%;
  .center {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    color:@text-color;
    text-align: center;
    overflow: hidden;
    h3 {
      font-size:30px;
      font-family: @PingFangSC-Semibold;
      font-weight:600;
      line-height:42px;
      margin-top: 67px;
    }
    &>p {
      font-size:18px;
      font-family: @PingFangSC-Regular;
      font-weight:400;
      line-height:25px;
      margin-top: 10px;
    }
    .content {
      margin-top: 75px;
      .col {
        font-size:22px;
        font-family: @PingFangSC-Semibold;
        font-weight:600;
        color:rgba(255,97,61,1);
        line-height:30px;
      }
      .list {
        margin-bottom: 50px;
        font-size: 0px;
        height: 30px;
        line-height:30px;
        &>p {
          display: inline-block;
          vertical-align: middle;
          font-size:14px;
          font-family: @PingFangSC-Regular;
          font-weight:400;
          margin-right: 28px;
          width: 170px;
          text-align: right;
        }
        &>div {
          display: inline-block;
          vertical-align: middle;
          height: 30px;
          width: 715px;
          position: relative;
          .tip {
            position: absolute;
            right: 0;
            top: -30px;
            height: 100%;
            line-height: 30px;
            .p {
              font-size:14px;
              font-family: @PingFangSC-Regular;
              font-weight:400;
            }
            .col {
              padding: 0 65px;
            }
          }
        }
      }
      .list:nth-child(1) {
        &>div {
          background: url('@{image}welfare1.png') no-repeat center center / 100% 100%;
        }
      }
      .list:nth-child(2) {
        &>div {
          background: url('@{image}welfare2.png') no-repeat center center / 100% 100%;
        }
      }
      .info {
        font-size:22px;
        font-family: @PingFangSC-Regular;
        font-weight:400;
        line-height:30px;
      }
    }
  }
}
</style>
